import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import { CustomDatePicker } from '../../../datepicker'
import { Input } from '../../../input'

import { CompanyInfoFirstCol } from './first-column'
import { CompanyInfoSecondCol } from './second-column'

import { FONTS } from '../../../../constants'

export const MovementInfo = React.memo(props => {
  const {
    emp,
    invalid,
    _companys,
    _lobs,
    _positions,
    _departments,
    _divisions,
    _teams,
    handleInput,
  } = props

  return (
    <Root>
      <Container>
        <MovementSection>
          <FormGroup>
            <FormWrapper>
              <Label required>Movement Name</Label>
              <Input
                name='name'
                placeholder='Enter Movement Name'
                invalid={ invalid['name'] }
                value={ emp.name || '' }
                onChange={ e => handleInput(e.target.value, 'name') }
              />
            </FormWrapper>
            <FormWrapper>
              <Label required>Start Date</Label>
              <CustomDatePicker
                showYearDropdown
                showMonthDropdown
                autoComplete='off'
                name='start_date'
                dateFormat='DD/MM/YYYY'
                invalid={ invalid['start_date'] }
                selected={ emp.start_date ? moment(emp.start_date) : null }
                onChange={ e => handleInput(e, 'start_date') }
              />
            </FormWrapper>
          </FormGroup>
          <FormGroup>
            <MovementWrapper>
              <Label>Description (Remarks)</Label>
              <Input
                name='description'
                placeholder='Enter Description'
                value={ emp.description || '' }
                onChange={ e => handleInput(e.target.value, 'description') }
              />
            </MovementWrapper>
          </FormGroup>
        </MovementSection>
        <Form>
          <CompanyInfoFirstCol
            _companys={ _companys }
            _lobs={ _lobs }
            _positions={ _positions }
            _departments={ _departments }
            emp={ emp }
            handleInput={ handleInput }
          />
          <CompanyInfoSecondCol
            _divisions={ _divisions }
            _teams={ _teams }
            emp={ emp }
            handleInput={ handleInput }
          />
        </Form>
      </Container>
    </Root>
  )
})

const Root = styled.div`
    display: flex;
    flex-direction: column;
`

const Container = styled.div`
    padding: 16px 24px;
    background: #FFFFFF;
    max-height: calc(100vh - 223px);
    overflow-y: scroll;
`

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;

    ${p => p.required && `
      ::after {
        content: '*';
        color: red;
      }
    `}
`

const Form = styled.div`
  display: flex;
  background: #F9F9F9;
  border: 1px solid #EAEAEA;
  border-radius: 4px;
  padding: 12px;
`

const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    :nth-child(1) {
        padding-right: 6px;
    }

    :nth-last-child(1) {
        padding-left: 6px;
    }
`

const FormGroup = styled.div`
    display: flex;
    margin-bottom: 16px;
`

const MovementSection = styled.div`
  display: flex;
  flex-direction: column;
`

const MovementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/create-form/movement-info/index.js